import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', function () {
    // News preview slider
    var newsPreviewSlider = document.querySelector('.abi-transHerHome__introNewsPreviewSlider');
    if (newsPreviewSlider) {
        var slider2 = new Splide(newsPreviewSlider, {
            speed: 500,
        });
        slider2.mount();
    }
    // Players ranking slider
    var rankingSlider = document.querySelector('.abi-transHerHome__introRankingSlider');
    if (rankingSlider) {
        var slider2 = new Splide(rankingSlider, {
            gap: '8px',
            grid: {
                dimensions: [[3, 1]],
                gap: {
                    row: '8px',
                },
            },
        });
        slider2.mount({ Grid: Grid });
    }
    // News slider
    var news = document.querySelector('.abi-transHerNews');
    if (news) {
        var sliderNews = new Splide(news, {
            pagination: false,
            direction: 'ttb',
            height: '756px',
            gap: 24,
            perPage: 2,
            perMove: 2,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    direction: 'ltr',
                    height: 'auto',
                    perMove: 3
                }
            }
        });
        sliderNews.mount();
    }
    // Players  slider
    var playerSliders = document.querySelectorAll('.abi-transHerPlayers__slider');
    if (playerSliders) {
        playerSliders.forEach(function (playerSlider) {
            var players = playerSlider.querySelectorAll('.splide__slide'), playersLength = players.length;
            players.forEach(function (player) {
                var lastTap = 0;
                var timeout;
                /* Regex test to determine if user is on mobile */
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    player.addEventListener('touchend', function (event) {
                        var currentTime = new Date().getTime();
                        var tapLength = currentTime - lastTap;
                        event.preventDefault();
                        player.classList.add('flip');
                        if (tapLength < 700 && tapLength > 0) {
                            window.location.href = player.href;
                            player.classList.remove('flip');
                        }
                        else {
                            timeout = window.setTimeout(function () {
                                clearTimeout(timeout);
                                player.classList.toggle('flip');
                            }, 700);
                        }
                        lastTap = currentTime;
                    }, { passive: false });
                }
            });
            if (playersLength >= 3) {
                new Splide(playerSlider, {
                    gap: 24,
                    pagination: false,
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            perMove: 4
                        },
                        1024: {
                            perMove: 6
                        }
                    }
                }).mount();
            }
            if (playersLength >= 1 && playersLength < 3) {
                new Splide(playerSlider, {
                    gap: 24,
                    perMove: 1,
                    pagination: false,
                    breakpoints: {
                        768: {
                            perMove: 2,
                        }
                    }
                }).mount();
            }
        });
    }
});
